




import Vue from '../../helpers/VueBase';
import SentryHelper from '../../helpers/SentryHelper';

export default Vue.extend({
  data() {
    return {};
  },
  async mounted() {
    await this.checkIfLoggedIn();
  },
  methods: {
    async checkIfLoggedIn() {
      const isLoggedIn = await this.$zApiService.getLoginCheck();
      if(isLoggedIn && window.sentryInitialized) {
        SentryHelper.setSentryTags();
      }
    },
  },
});
